import throttle from 'lodash.throttle'
import Css from './Css.js';
import SlideBall from './SlideBall/SlideBall.js';
import React, { useState, useEffect} from 'react';
import orderUtil from '../Utils/orderUtil.js';
import SlideLimit from "./SlideLimit/SlideLimit.js";

function ControlBox(props){
  //控制球位置控制
  const [conBoxBottom, setConBoxBottom] = useState(0);
  const {editorMode,levelRange,isPlay,points,progress,videoEl,level,lvsPatternEditorId} = props.data;
  const controlBoxId = lvsPatternEditorId + "_controlBox";
  const controlBallImgId = lvsPatternEditorId + "_controlBallImg";
  const controlBoxEl = document.getElementById(controlBoxId);
  const {setLevel,setLevelRange,setPoints,pauseVideo,mouseMoveToControlBoxArea} = props.method;

  //视频播放覆盖重画曲线
  const [isMouseDown, setIsMouseDown] = useState(false);
  const [changePointTime, setChangePointTime] = useState(null);
  useEffect(()=>{
    if(editorMode.edMode === 1 && isPlay){
      let backupArr = orderUtil.deepClone(points);
      let arrLength = backupArr.length;
      if(arrLength > 0){
        let time2 = orderUtil.formatMs(progress);
        let lastPointTime = backupArr[arrLength - 1].t;
        if(time2 <= lastPointTime){
          let tp = backupArr.find(i => i.t === time2);
          if(tp){
            if(tp.v !== level && changePointTime !== time2){
              setChangePointTime(time2);
              let newPoint = {t:tp.t, v:level};
              let pos = backupArr.indexOf(tp);
              let leftArr = backupArr.slice(0, pos);
              let rightArr = backupArr.slice(pos+1);
              leftArr.push(newPoint);
              let arr = leftArr.concat(rightArr);
              setPoints(arr);
            }
          }
        }
      }
    }
  },[progress,points,level,isMouseDown,changePointTime,setPoints,editorMode,isPlay])

  //滑动震动球处理 start
  let timer = null;
  //滑动球的上下滑动范围
  const min = orderUtil.coMinHeight;
  const max = orderUtil.coMaxHeight;
  const lvHeight = orderUtil.oneLevelHeight;
  const [mouseDownY, setMouseDownY] = useState(null);
  const [oldBottom, setOldBottom] = useState(0);
  const onMouseDownEvent = (e)=> {
    e.stopPropagation();
    e.preventDefault();
    setIsMouseDown(true);
    setMouseDownY(e.clientY);
    setOldBottom(conBoxBottom);
  }

  //滑动计算选区(节流计算) 
  const onMouseMoveEvent = throttle(function(ev) {
    if(editorMode.edMode === 1 && isMouseDown){
      let moveDistance = mouseDownY - ev.clientY + oldBottom;
      if(moveDistance >= -20 && moveDistance <= 180){
        let bottom = parseInt(Math.floor((moveDistance - min)/lvHeight)*lvHeight + min);
        if(bottom >= min && bottom <= max){
          setConBoxBottom(bottom);
        }
        if(bottom < min){
          bottom = min;
        }else if(bottom > max){
          bottom = max;
        }
        syncSetLevel(bottom)
      }
      controlBoxEl.onmouseup = function(){
        controlBoxEl.onmousedown = null;
        controlBoxEl.onmousemove = null;
      };
      return false;
    }
  }, 10);

  const onMouseUpEvent = (e) => {
    setIsMouseDown(false);
    setChangePointTime(null);
  }
  //滑动震动球处理 end

  const mouseEnterControlBox = (e) => {
    if(e.buttons !== 1){ //鼠标左键没有按下
      setIsMouseDown(false);
      setMouseDownY(null);
      if(controlBoxEl){
        controlBoxEl.onmousemove = null;
        controlBoxEl.onmousedown = null;
        controlBoxEl.onmousemove = null;
      }
    }else{ //鼠标左键按下进入右侧控制球区域
      setTimeout(()=>{
        mouseMoveToControlBoxArea();
      },20);
    }
  }

  const onMouseWheelEvent = throttle(function(ev) {
    let deltaY = (ev.deltaY || ev.detail) / -100 * 21 // 每次滚动幅度 21/-21
    if(editorMode.edMode === 1) {
      let bottom = conBoxBottom + deltaY
      if (bottom < min){
        bottom = min
      } else if (bottom > max){
        bottom = max
      }
      setConBoxBottom(bottom)
      syncSetLevel(bottom)
      return false
    }
  }, 10)

  const syncSetLevel = (bottom) => {
    let levelTmp = orderUtil.getLevel(bottom, min, max)
    if (levelRange && levelTmp > levelRange.max){
      levelTmp = levelRange.max
    } else if (levelRange && levelTmp < levelRange.min){
      levelTmp = levelRange.min
    }
    setLevel(levelTmp)
    if (!timer) {
      if(isPlay && editorMode.edMode === 1){
        let tmpPointsArr = orderUtil.deepClone(points)
        let currentTimePoint = tmpPointsArr.find(i => i.t === progress)
        if(currentTimePoint) {
          // currentTimePoint.v = levelTmp;
          // setPoints(tmpPointsArr);
        } else {
          let curTime = orderUtil.formatMs(parseInt(videoEl.currentTime*1000))
          if(tmpPointsArr.length > 0){
            let prevTime = curTime - tmpPointsArr[tmpPointsArr.length - 1].t
            if(prevTime < 100 && prevTime > 0){
              //两点相隔少于0.1s，不添加当前点
              return
            }
          }
          let point = { t: curTime, v:levelTmp}
          let tp = tmpPointsArr.find(i => i.t === curTime)
          if(!tp){
            tmpPointsArr.push(point)
            tmpPointsArr.sort((a, b) => a.t - b.t)
            setPoints(tmpPointsArr)
          }else{
            //重复时刻的点，t不变，只更新v
            let index = orderUtil.getPointIndex(tmpPointsArr, curTime)
            tmpPointsArr[index].v = levelTmp
            setPoints(tmpPointsArr)
          }
        }
      }
      timer = setTimer(100)
    }
  }

  useEffect(() => {
    const onMouseWheel = (ev) => {
      ev = ev || window.event
      if (ev.preventDefault) {
        ev.preventDefault()
      }
      onMouseWheelEvent(ev)
      return false
    }
    let targetNode = document.getElementById(lvsPatternEditorId + '-control-area')
    if (targetNode) {
      targetNode.addEventListener('mousewheel',onMouseWheel, false);
      targetNode.addEventListener('DOMMouseScroll',onMouseWheel, false); //兼容Firefox
    }
    return function () {
      if (targetNode) {
        targetNode.removeEventListener('mousewheel',onMouseWheel, false);
        targetNode.removeEventListener('DOMMouseScroll',onMouseWheel, false); //兼容Firefox
      }
    }
  }, [conBoxBottom, lvsPatternEditorId, oldBottom, onMouseWheelEvent])
  
  function setTimer(T) {
    return setTimeout(function() {
      timer = null;
    }, T);
  }
  
  return (
    <div 
      id={controlBoxId}
      style={ Css.ControlBox(orderUtil.controlBoxWidth, isMouseDown) }
      onMouseEnter={ (e)=>{mouseEnterControlBox(e)} }
      onMouseMove={ (e)=>{onMouseMoveEvent(e)} }
      onMouseUp={ (e)=>{ onMouseUpEvent(e) } }
    >
      <SlideLimit data={{controlBoxId,level,points}} method={{setLevelRange,pauseVideo,setLevel,setPoints}}></SlideLimit>
      <SlideBall
        data={{levelRange,conBoxBottom,editorMode,controlBallImgId}}
        onMouseDownEvent={ (e)=>{ onMouseDownEvent(e) } }
        onMouseUpEvent={ (e)=>{ onMouseUpEvent(e) } }
      >
      </SlideBall>
    </div>
  )
}

export default ControlBox;